import * as runtypes from 'runtypes';
import * as system from 'src/models/system';

export const SystemInstitution = runtypes.Record({
  system: system.types.System,
  localeIdentifier: runtypes.String
});

export type SystemInstitution = runtypes.Static<typeof SystemInstitution>;
